"use client";

import { useModal } from "@/app/providers/modal-provider";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

type Props = {
  title: string;
  subheading: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
};

const CustomModal = ({ title, subheading, children, defaultOpen }: Props) => {
  const { isOpen, setClose } = useModal();

  return (
    <Dialog open={isOpen || defaultOpen} onOpenChange={setClose}>
      <DialogContent
        className="
          w-[92vw] rounded-2xl border border-slate-300 bg-gradient-to-b from-slate-50 to-white p-0 shadow-[0_30px_80px_-45px_rgba(15,23,42,0.65)]
          [&>button]:right-3 [&>button]:top-3 [&>button]:inline-flex [&>button]:h-8 [&>button]:w-8 [&>button]:items-center [&>button]:justify-center [&>button]:rounded-full [&>button]:border [&>button]:border-slate-300 [&>button]:text-slate-500 [&>button]:transition [&>button]:hover:bg-slate-100 [&>button]:hover:text-slate-800
          dark:border-white/10 dark:from-slate-950 dark:to-slate-950 dark:shadow-[0_30px_80px_-45px_rgba(2,6,23,0.9)] dark:[&>button]:border-white/20 dark:[&>button]:text-slate-300 dark:[&>button]:hover:bg-slate-800 dark:[&>button]:hover:text-slate-100 sm:max-w-lg
        "
      >
        {/* Sticky header with close button */}
        <div className="sticky top-0 z-10 border-b border-slate-300/90 bg-slate-50/95 px-5 py-4 dark:border-white/10 dark:bg-slate-950/95">
          <DialogHeader className="text-left space-y-1">
            <DialogTitle className="text-lg font-semibold leading-tight text-slate-900 dark:text-slate-100">
              {title}
            </DialogTitle>
            {subheading ? (
              <DialogDescription className="text-sm text-slate-600 dark:text-slate-300">
                {subheading}
              </DialogDescription>
            ) : null}
          </DialogHeader>
        </div>

        {/* Scrollable body with safe height on mobile */}
        <div
          className="
            px-5 py-4
            overflow-y-auto overscroll-contain
            max-h-[75vh] md:max-h-[70vh]
          "
        >
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CustomModal;
